import { validateCollectionName } from 'components/AppDetail/Data/Panel/Items/validations'

const validation = value => {
  return validateCollectionName(value)
}

export default validation
